/**
 * Substitui tokens `{chave}` num template por valores de um dicionário.
 *
 * Usado nos textos de proposta persistidos em `platform_settings`
 * (migration 0053) — Karla/Alexandre editam o template pela UI do
 * Superadmin e o consumer público substitui tokens como `{firstName}`
 * e `{destinatario}` no momento do render.
 *
 * Regras:
 *  - Token desconhecido fica como-veio (`{unknown}` permanece literal).
 *    Defense in depth: se alguém salvar template com chave errada, o
 *    lead vê "{algo}" explicitamente, em vez de texto quebrado.
 *  - Valores vazios/null/undefined são tratados como string vazia —
 *    o token é removido sem espaço residual.
 *  - Regex simples `\{(\w+)\}` — chaves precisam começar com letra/dígito
 *    e conter só word chars (latim + dígitos + underscore), batendo com
 *    convenção adotada nos seeds.
 *
 * Função pura, sem React. Testada isoladamente em `token-replace.test.ts`. */
export function replaceTokens(
  template: string,
  tokens: Readonly<Record<string, string | null | undefined>>,
): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    if (!(key in tokens)) return match; // Token desconhecido → deixa como veio.
    const value = tokens[key];
    return value == null ? '' : value;
  });
}
